import wx from 'weixin-js-sdk'
import request from '@/utils/request'
import { API } from '@/service/apiConfig'
import { getLocalUrl, isFunc } from './util'
import { getToken } from "@/utils/storage";

export let wxChooseImage = () => {
  return new Promise((resolve, reject) => {
    wx.ready(() => {
      wx.chooseImage({
        count: 1, // 默认9
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: resolve,
        fail: reject
      })
    })
  })
}
export let wxJumpPlugin = {
  install(Vue, options) {
    Vue.prototype.wxJumpPage = (url = '') => {
      wx.miniProgram.navigateTo({ url: url })
    }
    Vue.prototype.wxBackPage = (delta = 1) => {
      wx.miniProgram.navigateBack({ delta: delta })
    }
    Vue.prototype.wxReLaunchPage = (url = '') => {
      wx.miniProgram.reLaunch({ url: url })
    }
    Vue.prototype.wxRedirectPage = (url = '') => {
      wx.miniProgram.redirectTo({ url: url })
    }
    Vue.prototype.wxSwitchTab = (url = '') => {
      wx.miniProgram.switchTab({ url: url })
    }
  }
}
/**
 * wxsdk初始化
 * @param {Object} data
 *  {Object} config 补充wx.config参数，可配置jsApiList，openTagList，debug等
 *  {Function} success 成功回调
 *  {Function} failed 失败回调
 *  {String} url 接口参数地址 默认window.location.href
 */
export let initWxConfig = (data = {}) => {
  if (!getToken()) return
  let { config, success, failed, url } = data
  if(url.includes("isPreView=true")) return
  request({
    method: 'get',
    url: API.wxConfig,
    params: {
      uType: 'DOCTOR',
      url: decodeURIComponent(window.__wxjs_is_wkwebview ? window.wxShareLink : url)
    }
  }).then((res) => {
    wx.config({
      debug: false,
      appId: res.data.appId,
      timestamp: res.data.timestamp,
      nonceStr: res.data.nonceStr,
      signature: res.data.signature,
      ...config
    })
    wx.error((msg) => {
    })
    isFunc(success) && success()
  })['catch'](failed)
}
/**
 * 设置分享
 * @param {Object} data {url:链接 ,title:标题 ,image:图片 ,content:内容 ,func:成功回调 ,wxConfig:(默认可不传)微信config配置,是否debug等}
 */
export let onWxShare = (data = {}) => {
  if (!window.__wxjs_is_wkwebview) {
    setTimeout(() => {
      init(data)
    }, 500)
  } else {
    init(data)
  }
}

function init(data) {
  let {
    url = getLocalUrl(),
    title = '趣学术趣直播',
    image = '',
    content = '',
    func,
    wxConfig
  } = data
  let config = {
    jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData', 'showOptionMenu', 'onMenuShareTimeline', 'onMenuShareAppMessage'],
    ...wxConfig
  }
  initWxConfig({ config, success, failed, url })

  function success(res) {
    wx.ready(() => {
      wx.error((msg) => {
        console.log('shareFailed:', msg)
      })
      setShowMenuOptions()
      setWxTimeLine({
        title: title,
        url: url,
        image: image,
        desc: content,
        func: func
      })
      setWxMessageData({
        title: title,
        url: url,
        image: image,
        desc: content,
        func: func
      })
    })
  }

  function failed(reason) {
  }
}

/**
 * 隐藏菜单
 * @param {Object} data {allowShare:是否允许分享 ,wxConfig:(默认可不传)微信config配置,是否debug等}
 */
export let wxHideOptionMenu = (allowShare = false, wxConfig = {}) => {
  if (allowShare) return
  let config = {
    jsApiList: ['hideOptionMenu', 'showOptionMenu'],
    ...wxConfig
  }
  initWxConfig({ config, success, failed, url: getLocalUrl() })

  function success(res) {
    wx.ready(() => {
      setHideMenuOptions()
    })
  }

  function failed(rea) {
  }
}
/**
 * 微信网页打开小程序（只是测试功能用了下，实际并未用到）
 * @param {Object} data {wxConfig:(默认可不传)微信config配置,是否debug等}
 */
export let wxOpenLaunchApp = (data = {}) => {
  let { wxConfig } = data
  let config = {
    jsApiList: ['hideOptionMenu'],
    openTagList: ['wx-open-launch-weapp'],
    ...wxConfig
  }
  initWxConfig({ config, success, failed, url: getLocalUrl() })

  function success(res) {
    wx.ready(() => {
      wx.hideOptionMenu()
    })
  }

  function failed(rea) {
    console.log(rea)
  }
}
/**
 * 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容(注：不可单独始使用方法，需使用onWxShare先，如有需要再次改变分享内容，可使用此方法)
 * @param {Object} param0 {title：标题， link:链接 ,imgUrl:封面 ,desc:描述 ,func:成功回调}
 */
export let setWxTimeLine = (data = {}) => {
  let { title, url, image, desc = '', func } = data
  wx.updateTimelineShareData({
    title: title, // 分享标题
    link: url, // 分享链接
    imgUrl: image, // 分享图标
    success: function () {
      isFunc(func) && func()
    }
  })
  wx.onMenuShareTimeline({
    title: title, // 分享标题
    link: url, // 分享链接
    imgUrl: image, // 分享图标
    success: function () {
      isFunc(func) && func()
    }
  })
}
/**
 * 自定义“分享给朋友”及“分享到QQ”按钮的分享内容(注：不可单独始使用方法，需使用onWxShare先，如有需要再次改变分享内容，可使用此方法)
 * @param {Object} param0 {title：标题， link:链接 ,imgUrl:封面 ,desc:描述 ,func:成功回调}
 */
export let setWxMessageData = (data = {}) => {
  let { title, url, image, desc = '', func } = data
  wx.updateAppMessageShareData({
    title: title, // 分享标题
    link: url, // 分享链接
    imgUrl: image, // 分享图标
    desc: desc,
    success: function () {
      isFunc(func) && func()
    }
  })
  wx.onMenuShareAppMessage({
    title: title, // 分享标题
    link: url, // 分享链接
    imgUrl: image, // 分享图标
    desc: desc,
    success: function () {
      isFunc(func) && func()
    }
  })
}
/**
 * 设置菜单开（注：由于每个页面已经调用wxHideOptionMenu方法，jsApiList已经注入config,可单独使用）
 */
export let setShowMenuOptions = () => {
  wx.showOptionMenu()
}
/**
 * 设置菜单关（注：由于每个页面已经调用wxHideOptionMenu方法，jsApiList已经注入config,可单独使用）
 */
export let setHideMenuOptions = () => {
  wx.hideOptionMenu({
    success: () => {
    },
    fail: (rea) => {
      console.log('hide失败', rea)
      // setHideMenuOptions()
    }
  })
}
/**
 *  wx.config 的封装
 *  // configObj wx.config()  固定必填属性
 *  @param configObj:object {
 *		beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
 *		debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
 *		appId: '', // 必填，企业微信的corpID
 *		timestamp: , // 必填，生成签名的时间戳
 *		nonceStr: '', // 必填，生成签名的随机串
 *		signature: '',// 必填，签名，见 附录-JS-SDK使用权限签名算法
 *
 * 	}
 *
 *  // changeAttribute   wx.config() 可定义的必填和可选属性
 *  @param changeAttribute: object  {
 * 		jsApiList: [] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
 * 		openTagList: ["wx-open-launch-weapp"]
 * 	}
 *  @param callBack: function; wx.config()成功后触发
 *  @param errBack: function; wx.config()失败后触发 err错误信息
 *  @return null
 *
 */
export const wxConfigFun = (configObj, changAttribute, callBack, errBack) => {
  let { beta = true, debug = false, appId, timestamp, nonceStr, signature } = configObj
  let obj = Object.assign(
    {},
    { beta, debug, appId, timestamp, nonceStr, signature },
    changAttribute
  )
  wx.config(obj)
  wx.ready(() => {
    callBack && callBack()
  })
  wx.error(err => {
    errBack && errBack(err)
  })
}
/**
 * 调起微信支付弹窗
 * @param {Object} data
 *  {Object} data.wxConfig = {debug:[Boolean],appId:[String],timestamp:[String],nonceStr:[String],signature:[String],jsApiList:[Arrary]}
 *  {Object} data.config = {timestamp:[String],nonceStr:[String],package:[String],signType:[String],paySign:[String]}
 *  {Function} data.success
 *  {Function} data.cancel
 *  {Function} data.fail
 */
export let onWxPay = (data = {}) => {
  let { wxConfig, payConfig, success, cancel, fail } = data
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: '',      // 必填，公众号的唯一标识
    timestamp: '',   // 必填，生成签名的时间戳
    nonceStr: '',   // 必填，生成签名的随机串
    signature: '',  // 必填，签名
    jsApiList: ['chooseWXPay'],  // 必填，需要使用的JS接口列表
    ...wxConfig
  })
  wx.ready(() => {
    wx.chooseWXPay({
      timestamp: payConfig.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      nonceStr: payConfig.nonceStr, // 支付签名随机串，不长于 32 位
      package: payConfig.prePayId, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
      signType: payConfig.signType, // 签名方式，默认为´SHA1´，使用新版支付需传入´MD5´
      paySign: payConfig.sign, // 支付签名
      success: (res) => {
        isFunc(success) && success(res)
      },
      cancel: (res) => {
        isFunc(cancel) && cancel(res)
      },
      fail: (err) => {
        isFunc(fail) && fail(err)
      }
    })
  })
}

/**
 * 检查微信摄像头权限
 * @returns {Promise} 返回授权状态的Promise
 */
export const checkWxCameraPermission = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      reject(new Error('浏览器不支持摄像头功能'))
      return
    }

    console.log('navigator.mediaDevices.getUserMedia: ', navigator.mediaDevices.getUserMedia)
    // Test if camera can be accessed
    navigator.mediaDevices.getUserMedia({
      audio: false,
      video: {
        facingMode: 'user'
      }
    }).then(stream => {
      // Stop all tracks after successful test
      stream.getTracks().forEach(track => track.stop())
      resolve()
    }).catch(error => {
      reject(new Error('无法访问摄像头，请确保已授予摄像头权限'))
    })
  })
}
